import { MoveGenerator } from '../../jscaip/AI/AI';
import { QuebecCastlesDrop, QuebecCastlesMove } from './QuebecCastlesMove';
import { QuebecCastlesRules } from './QuebecCastlesRules';
export class QuebecCastlesMoveGenerator extends MoveGenerator {
    getListMoves(node, config) {
        const state = node.gameState;
        if (QuebecCastlesRules.get().isDropPhase(state, config)) {
            return this.getDropMoves(state, config);
        }
        else {
            return this.getNormalMoves(state, config);
        }
    }
    getDropMoves(state, config) {
        const player = state.getCurrentPlayer();
        const moves = [];
        const rules = QuebecCastlesRules.get();
        const nbOfDropsAwaited = rules.getExpectedDropsThisTurn(state, config);
        const mustPlaceCastle = rules.mustPlaceCastle(state, config);
        if (config.dropMode === 'PIECE_BY_PIECE' || mustPlaceCastle) {
            const coords = [];
            const validDropCoords = rules.getValidDropCoords(player, config);
            for (const dropCoord of validDropCoords) {
                const piece = state.getPieceAt(dropCoord);
                if (piece.isNone() && state.castles.get(player).equalsValue(dropCoord) === false) {
                    if (nbOfDropsAwaited === 1) {
                        moves.push(QuebecCastlesDrop.of([dropCoord]));
                    }
                    else {
                        coords.push(dropCoord);
                        if (nbOfDropsAwaited === coords.length) {
                            return [QuebecCastlesDrop.of(coords)];
                        }
                    }
                }
            }
        }
        else {
            const initialCoords = QuebecCastlesRules.get().getInitialCoords(player, state, config);
            const move = QuebecCastlesMove.drop(initialCoords);
            moves.push(move);
        }
        return moves;
    }
    getNormalMoves(state, config) {
        const player = state.getCurrentPlayer();
        const moves = [];
        for (const coordAndContent of state.getCoordsAndContents()) {
            if (coordAndContent.content.equals(player)) {
                const movesForCoord = QuebecCastlesRules.get().getPossibleMovesFor(coordAndContent.coord, state);
                moves.push(...movesForCoord);
            }
        }
        return moves;
    }
}
